var _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlotPms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    width: 1024,
    height: 1024,
    role: "img",
    "aria-label": "Growth",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "card",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7249D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#452299"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "lift",
    x: "-10%",
    y: "-10%",
    width: "125%",
    height: "125%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 6,
    stdDeviation: 6,
    floodColor: "#25105C",
    floodOpacity: 0.28
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1024,
    height: 1024,
    rx: 194.9,
    fill: "url(#card)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mark",
    fill: "#fff",
    filter: "url(#lift)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 509.1,
    cy: 270.4,
    r: 99.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.3 384.9L506.6 526.1L789.2 309.3",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 78.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.1,
    y: 677.1,
    width: 119.8,
    height: 160.8,
    rx: 24.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 460.4,
    y: 633.3,
    width: 119.8,
    height: 204.6,
    rx: 24.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674.7 591.9Q674.7 567.5 695.7 555.1L773.5 509.3Q794.5 496.9 794.5 521.3L794.5 813.5Q794.5 837.9 770.1 837.9L699.1 837.9Q674.7 837.9 674.7 813.5Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlotPms);
export default __webpack_public_path__ + "static/media/plot-pms.22e03621fb8f3791c59f1116f115a83f.svg";
export { ForwardRef as ReactComponent };